export enum EInviteTokenType {
    BOUND = 'BOUND',
    REUSABLE = 'REUSABLE',
}

export enum EInviteRedirect {
    ONBOARDING_PPA = 'ONBOARDING_PPA',
    PORTAL_HOME = 'PORTAL_HOME',
}

export type TInviteeSnapshot = {
    email?: string;
    firstName?: string;
    lastName?: string;
} | null;

export type TInviterSnapshot = {
    userId?: number;
    fullName?: string;
    credentials?: string | null;
    firstName?: string;
    lastName?: string;
    title?: string;
    avatar?: string | null;
} | null;

export type TOwnerSnapshot = TInviterSnapshot;

export type TInviteInfo = {
    invitee: TInviteeSnapshot;
    inviter: TInviterSnapshot;
    owner?: TOwnerSnapshot;
    isAdmin: boolean;
    isExistingUser: boolean;
    practiceName: string;
    roleCode: string;
    tokenType: EInviteTokenType;
};

export type TAcceptInviteReq = {
    email?: string;
    firstName?: string;
    lastName?: string;
    password: string;
    token: string;
};

export type TAcceptInviteRes = {
    isAdmin: boolean;
    memberId: number;
    organizationId: number;
    redirectTo: EInviteRedirect;
    role: string;
    scheduleToken: string;
    userId: number;
};
